<template>
    <div>
        <div
            v-if="!$wait.is('loading-page') && !notFound"
            class="m-careers m-careers__single"
        >
            <y-container>
                <y-row>
                    <y-col md="8">
                        <h3
                            v-if="post.title"
                            class="m-careers__single__title"
                        >
                            {{ post.title }}
                        </h3>
                        <y-page-content
                            v-if="post.text"
                            :content="post.text"
                        />
                    </y-col>
                    <y-col md="4">
                        <y-send-c-v :configs="configs" />
                    </y-col>
                </y-row>
            </y-container>

            <div class="open-modal-wrap">
                <y-button
                    size="medium"
                    :content="`${$t('careers.send_cv')} ${$t('careers.cv')}`"
                    color="primary"
                    class="open-modal"
                    block
                    flat
                    @click.prevent="open"
                />
            </div>

            <y-modal
                ref="modal"
                :title="`${$t('careers.send_cv')} ${$t('careers.cv')}`"
                fullscreen
                full-height
                no-footer
            >
                <y-send-c-v :configs="configs" />
            </y-modal>
        </div>
        <page-not-found v-if="notFound" />
    </div>
</template>

<script>
    // Mixins
    import PageMixin from '@groot-nodes/mixins/Page.js';

    // Components
    import { YPageContent, YModal } from '@groot-components/all';
    import YSendCV from '@modules/careers/components/SendCV/Index.vue';
    import PageNotFound from '@components/PageNotFound.vue';

    export default {
        name: 'CareersSingle',

        components: {
            PageNotFound,
            YModal,
            YSendCV,
            YPageContent,
        },

        mixins: [PageMixin],

        /**
         * @inheritdoc
         */
        data() {
            return {
                post    : null,
                configs : null,
                notFound: null,
            };
        },

        /**
         * @inheritdoc
         */
        metaInfo() {
            return {
                title: this.title,
            };
        },

        computed: {
            /**
             * Return page title
             *
             * @returns {string}
             */
            title() {
                return this.$t('careers.titles.single', [this.post?.title]);
            },
        },

        methods: {
            /**
             * Open Schedule Demo
             */
            open() {
                this.$refs.modal.open();
            },

            /**
             * Fetch Careers single data
             *
             * @returns {Promise}
             */
            fetch() {
                this.post = null;
                this.configs = null;

                const post = this.$services.Content.postSingle({
                    type     : 'hiring',
                    slug     : this.$route.params.url_encode,
                    including: ['title', 'text'],
                    locale   : this.$i18n.locale,
                }).catch((error) => {
                    if (error.response.data.status === '404') {
                        this.notFound = true;
                    }
                    this.handleError(error);
                });

                const configs = this.$services.Commenting.getFormConfig({
                    slug: this.$route.params.url_encode,
                    type: 'hiring',
                }).catch((error) => {
                    this.handleError(error);
                });

                return Promise.all([post, configs]).then((responses) => {
                    if (this.handleReq(responses, 0)) {
                        this.post = responses[0].data.results;
                    }

                    if (this.handleReq(responses, 1)) {
                        this.configs = {
                            ...responses[1].data.results,
                            recaptcha: responses[1].data.metadata.recaptcha,
                            payload  : responses[1].data.metadata.payload,
                            post_id  : this.post.id,
                        };
                    }
                }).catch((error) => {
                    this.handleError(error);
                });
            },
        },
    };
</script>

<style lang="scss" src="../scss/careers.scss" />
